import {
  fieldAcresColumn,
  fieldNameLocationColumn,
  fieldThumbnailColumn,
  SelectableFieldsTableProps,
  SelectablePaginatedFieldsTable,
} from '@cibo/landmanager'
import { fieldProgramProgressColumn } from '@cibo/programs'
import { GridColumns } from '@mui/x-data-grid-pro'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const NewEnrollmentFieldList = ({
  programId,
  ...tableProps
}: SelectableFieldsTableProps & { programId: string }) => {
  const { t } = useTranslation('@cibo/programs/components/SelectWorkflowFieldsTable')

  const columns = useMemo(
    () =>
      [
        fieldThumbnailColumn({ t }),
        fieldNameLocationColumn({ t }),
        fieldAcresColumn({ t }),
        { ...fieldProgramProgressColumn({ t, programId, readOnly: true }), sortable: false },
      ] as GridColumns,
    []
  )
  return <SelectablePaginatedFieldsTable columns={columns} {...tableProps} />
}
